import { Component, OnInit, ChangeDetectorRef } from '@angular/core';
import { NavController, LoadingController, AlertController } from '@ionic/angular';

import { Constants } from "../../models/constants";

import { Customer, UserService } from '../../services/user-service';
import { PaymentService } from "../../services/payment-service";
import { Alert } from "../../services/alert";

declare var Stripe: any;

@Component({
  selector: 'app-payment',
  templateUrl: './payment.page.html',
  styleUrls: ['./payment.page.scss'],
})
export class PaymentPage implements OnInit {

  cardFields: {
    cardholderName?: string
  } = {}

  stripe: any;
  card: any;

  editingCard?: string
  addingPayment = false

  constructor(
    private navCtrl: NavController,
    private paymentService: PaymentService,
    private loadingCtrl: LoadingController,
    public userService: UserService,
    private alert: Alert,
    private changeRef: ChangeDetectorRef,
    private alertController: AlertController,
  ) {

    if (Constants.DEV_MODE) {
      this.stripe = Stripe(Constants.DEV_STRIPE_KEY);
    } else {
      this.stripe = Stripe(Constants.STRIPE_KEY);
    }
  }

  ngOnInit() {}

  isDefault(customer: Customer) {
    return this.userService.user.customer && this.userService.user.customer.id == customer.id
  }

  returnToAccount() {

    if (this.userService.isBusiness) {
      this.navCtrl.navigateBack('/business')
      return
    }

    this.navCtrl.navigateBack('/account')
  }

  paymentCardText(customer: Customer) {
    if (customer.cardBrand) {
      return `${customer.cardBrand} ending *${customer.last4}`;
    } else {
      return `Card ending ${customer.last4}`;
    }
  }

  editCard(customer: Customer) {

    if (this.editingCard == customer.id) {
      this.closeEditCard()
      return
    }

    this.editingCard = customer.id;
    this.changeRef.detectChanges()
    let radioButton = document.getElementById('default-radio') as any;
    radioButton.checked = this.isDefault(customer)
  }

  closeEditCard() {
    this.editingCard = undefined
    this.changeRef.detectChanges()
  }

  saveIsDefault(customer: Customer) {
    var radio = document.getElementById('default-radio') as any;

    if (radio.checked) {
      this.selectCard(customer)
    }
    this.closeEditCard()
  }

  async selectCard(customer: Customer) {

    let loading = await this.loadingCtrl.create();
    loading.present();

    this.paymentService.selectPayment(customer.id, () => {
      loading.dismiss();
      this.changeRef.detectChanges()
    }, (errorMsg) => {
      loading.dismiss();
      this.error(errorMsg);
    });
  }

  async deleteCard(customer: Customer) {

    const alert = await this.alertController.create({
      header: 'Remove card',
      message: 'Do you want to delete this payment method?',
      buttons: [
        {
          text: 'Cancel',
          role: 'cancel',
          handler: (blah) => {
          }
        }, {
          text: 'Delete',
          handler: async () => {

            let loading = await this.loadingCtrl.create();
            loading.present();

            this.paymentService.removePayment(customer.id, () => {
              loading.dismiss();
              this.changeRef.detectChanges()
            }, (errorMsg) => {
              loading.dismiss();
              this.error(errorMsg);
            });
          }
        }
      ]
    });

    await alert.present();
  }



  addNewPayment() {
    this.addingPayment = true
    this.changeRef.detectChanges()
    this.setupStripe('card-element')
  }

  closeNewPayment() {
    this.addingPayment = false
    this.changeRef.detectChanges()
  }

  saveNewPayment() {

    this.addCard(() => {

      this.addingPayment = false
      this.changeRef.detectChanges()

    }, (errMsg: string) => {
      this.error(errMsg)
    })
  }



  private setupStripe(cardElementID: string){

    if (!document.getElementById(cardElementID)) {
      console.log('no card element')
      return
    }

    let elements = this.stripe.elements();
    var style = {
      base: {
        color: '#25282a',
        lineHeight: '50px',
        fontFamily: '"Fira Sans", Arial, sans-serif',
        fontSmoothing: 'antialiased',
        fontSize: '14px',
        '::placeholder': {
          color: '#86878e'
        },
        border: '1px solid grey'
      },
      invalid: {
        color: '#fa755a',
        iconColor: '#fa755a'
      }
    };

    this.card = elements.create('card', { style: style });

    this.card.mount('#' + cardElementID);

    this.card.addEventListener('change', (event: any) => {
      var displayError = document.getElementById('card-errors');
      if (event.error) {
        displayError.textContent = event.error.message;
      } else {
        displayError.textContent = '';
      }
    });
  }



  async addCard(
    success: () => void,
    error: (errMsg: string) => void) {

    if (!this.cardFields.cardholderName) {
      this.error('Please enter cardholder name.')
      return
    }

    let loading = await this.loadingCtrl.create()
    loading.present()

    let data = {
      name: this.cardFields.cardholderName
    }

    this.stripe.createToken(this.card, data).then((result: any) => {

      if (result.error) {
        var errorElement = document.getElementById('card-errors');
        errorElement.textContent = result.error.message;
        loading.dismiss()
      } else {

        this.paymentService.createCustomer(

          result.token,
          this.cardFields.cardholderName,

          () => {

            loading.dismiss()
            success()

          }, (errorMsg: string) => {

            loading.dismiss()
            error(errorMsg)

        });
      }
    });
  }



  private error(msg: string) {
    this.alert.show('Error', msg)
  }


}
